export const POLL_TYPES = {
  SIMPLE: 1,
  DETAILED: 2,
  SATISFACTION: 3,
};
